import { useState } from 'react'
import {
    Flex,
    Container,
    Stack,
    useColorModeValue,
    Heading,
    Text,
    Highlight
} from '@chakra-ui/react'

import config from '../../../Config/config'

import Plan from './Plan'

import { createCheckoutSession } from '../../../Api/Stripe'

import useIsAuthenticated from '../../../CustomHooks/useIsAuthenticated'
import useGlobalAlertDialog from '../../../Stores/useGlobalAlertDialog'

import { handleLogout } from '../../../Helpers/Auth'

import plans from '../../../Assets/Pricing/plans.json'
import pricing from '../../../Config/json/pricing.json'


const PlansList = () => {
    const displayGlobalAlertDialog = useGlobalAlertDialog((state) => state.displayGlobalAlertDialog)
    const closeGlobalAlertDialog = useGlobalAlertDialog((state) => state.closeGlobalAlertDialog)
    const isAuthenticated = useIsAuthenticated()

    const [isLoading, setIsLoading] = useState(false)

    const handleCreateCheckoutSession = async (planName, priceId) => {
        setIsLoading(true)

        if (isAuthenticated) {
            const response = await createCheckoutSession({ priceId })

            if (response.data.error) {
                if (response.data.errorType === 'sessionInvalid') {
                    displayGlobalAlertDialog({
                        title: response.data.errorType,
                        message: response.data.message,
                        primaryButton: {
                            label: 'Sign in',
                            handler: () => window.location.replace(config.AUTH_PAGE_URL + '/')
                        },
                        secondaryButton: {
                            label: 'Close',
                            handler: () => window.location.replace('/')
                        }
                    })

                    handleLogout(false)
                } else {
                    displayGlobalAlertDialog({
                        title: 'Something\'s wrong!',
                        message: response.data.message,
                        primaryButton: {
                            label: 'Ok',
                            handler: () => closeGlobalAlertDialog()
                        },
                        secondaryButton: {
                            label: null,
                            handler: () => null
                        }
                    })
                }

                setIsLoading(false)
            }

            if (!response.data.error) {
                window.location.replace(response.data.url)
            }
        } else {
            displayGlobalAlertDialog({
                title: 'Redirecting...',
                message: 'You will be redirected to our login page to continue.',
                primaryButton: {
                    label: null,
                    handler: () => null
                },
                secondaryButton: {
                    label: null,
                    handler: () => null
                }
            })

            setTimeout(() => {
                window.location.replace(config.AUTH_PAGE_URL + '/?selectedPlan=' + planName)
            }, 2000)
        }
    }

    return (
        <Flex
            w={'full'}
            h={'40vg'}
            pt={5}
            pb={'10vh'}
        >
            <Container
                maxW={'6xl'}
            >
                <Stack
                    direction={{ base: 'column', md: 'column', lg: 'row' }}
                    justify={'space-between'}
                    spacing={10}
                >
                    <Plan
                        name={'Free'}
                        description={'Perfect for students who just need a little extra help.'}
                        price={'$0/mo'}
                        priceHighlight={'$0'}
                        buttonLabel={'Try for free'}
                        features={pricing[0]['free']}
                        buttonOnClick={() => handleCreateCheckoutSession('Free', plans['free'].priceId)}
                        buttonIsLoading={isLoading}
                    />

                    <Plan
                        name={'Standard'}
                        description={'Ideal for students who are taking challenging courses.'}
                        price={'$2.49/mo'}
                        priceHighlight={'$2.49'}
                        buttonLabel={'Get started'}
                        bestValue={true}
                        features={pricing[0]['standard']}
                        buttonOnClick={() => handleCreateCheckoutSession('Standard', plans['standard'].priceId)}
                        buttonIsLoading={isLoading}
                    />

                    <Plan
                        name={'VIP'}
                        description={'Perfect for students who are serious about their studies.'}
                        price={'$3.99/mo'}
                        priceHighlight={'$3.99'}
                        buttonLabel={'Get started'}
                        features={pricing[0]['vip']}
                        buttonOnClick={() => handleCreateCheckoutSession('VIP', plans['vip'].priceId)}
                        buttonIsLoading={isLoading}
                    />
                </Stack>
            </Container>
        </Flex>
    )
}

export default PlansList